import { render, staticRenderFns } from "./req-buy-review.vue?vue&type=template&id=1099a309&scoped=true"
import script from "./req-buy-review.vue?vue&type=script&lang=js"
export * from "./req-buy-review.vue?vue&type=script&lang=js"
import style0 from "./req-buy-review.vue?vue&type=style&index=0&id=1099a309&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1099a309",
  null
  
)

export default component.exports